const TextAutosizeIcon = () => {
  return (
    <svg width="16" height="16" viewBox="30 5 48 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M60.5991 29.8972L73.9742 19.1504"
        stroke="currentColor"
        strokeWidth="5.01609"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.6792 19.2129L37.1274 19.2129"
        stroke="currentColor"
        strokeWidth="5.01609"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.9742 19.153L60.5991 8.40234"
        stroke="currentColor"
        strokeWidth="5.01609"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.1899 35.4873C35.7058 35.4873 34.5028 36.6904 34.5028 38.1745C34.5028 39.6586 35.7058 40.8617 37.1899 40.8617V35.4873ZM71.9731 40.8617C73.4572 40.8617 74.6603 39.6586 74.6603 38.1745C74.6603 36.6904 73.4572 35.4873 71.9731 35.4873V40.8617ZM39.8142 38.1738C39.8142 36.6897 38.6111 35.4866 37.1271 35.4866C35.643 35.4866 34.4399 36.6897 34.4399 38.1738H39.8142ZM34.4399 69.877C34.4399 71.361 35.643 72.5641 37.1271 72.5641C38.6111 72.5641 39.8142 71.361 39.8142 69.877H34.4399ZM37.1899 40.8617H71.9731V35.4873H37.1899V40.8617ZM34.4399 38.1738V69.877H39.8142V38.1738H34.4399Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TextAutosizeIcon;
